module.exports = __webpack_public_path__ + "bdc3a064a3e5c8ba8be08e9414e60913.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/accessibility/typewritter.svg
// module id = b1Ns
// module chunks = 0